import { render, staticRenderFns } from "./SeriviceCard.vue?vue&type=template&id=03d86a62&"
import script from "./SeriviceCard.vue?vue&type=script&lang=js&"
export * from "./SeriviceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports